import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  Input,
  OnDestroy
} from '@angular/core';
import { IBaseTable } from 'projects/registro-personas-empresas/src/app/shared/util/base-table.util';
import {
  TramiteTableColumnModel,
  tramiteTableColumns
} from '../../utils/tramite-table-columns.util';
import { Router } from '@angular/router';
import { entityCurrentEmpresaLoadRequest } from '../../../empresas/entity-mis-empresas/entity-current-empresa.actions';
import { Store, select } from '@ngrx/store';
import { CurrentEmpresa } from '@rpe/registro-personas-empresas-lib';
import { EntidadesProductivaNombrePFoJ } from '../../../empresas/entity-entidad-productiva/entity-entidades-productiva.model';
import { Subscription } from 'rxjs';
import { TramiteStatus } from '../../../tramites/tramite-status/tramite-status.model';
import { selectAllTramiteStatus } from '../../../tramites/tramite-status/tramite-status.selectors';
import { State } from '../../../vista-usuario/vista-usuario.state';

@Component({
  selector: 'rpe-vista-tramite-table',
  templateUrl: './vista-tramite-table.component.html',
  styleUrls: ['./vista-tramite-table.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class VistaTramiteTableComponent implements OnInit, OnDestroy {
  returnRoute = `/empresas/registro-empresa?continuar=true`;

  tramiteStatusSubscription: Subscription;

  tramiteStatus: TramiteStatus[] = [];

  @Input()
  set tramiteTableInput(tti: TramiteTableColumnModel[]) {
    if (tti) {
      this._tramiteTableInput = tti;
      this.baseTable = {
        ...this.baseTable,
        dataSource: tti
      };
    }
  }
  get tramiteTableInput(): TramiteTableColumnModel[] {
    return this._tramiteTableInput;
  }

  _tramiteTableInput: TramiteTableColumnModel[] = [];

  baseTable: IBaseTable<TramiteTableColumnModel> = {
    dataSource: this._tramiteTableInput,
    columns: tramiteTableColumns,
    actions: [
      {
        name: 'Continuar registro',
        icon: '',
        action: (element: TramiteTableColumnModel) => {
          this.onSelectEmpresa({
            idEntidadProductiva: element.entidadProductivaId,
            nombrePersonaFoJ: element.empresa
          });
        },
        hide: (element: TramiteTableColumnModel) => {
          return (
            element.estado === this.getTramiteStatusById(1).estado_nombre ||
            element.estado === this.getTramiteStatusById(11).estado_nombre ||
            element.estado === this.getTramiteStatusById(5).estado_nombre ||
            element.estado === this.getTramiteStatusById(7).estado_nombre ||
            element.estado === this.getTramiteStatusById(25).estado_nombre
          );
        }
      }
    ]
  };

  constructor(private router: Router, private store: Store<State>) {}

  ngOnInit(): void {
    this.tramiteStatusSubscription = this.store
      .pipe(select(selectAllTramiteStatus))
      .subscribe((tramiteStatus) => {
        this.tramiteStatus = tramiteStatus;
      });
  }

  ngOnDestroy(): void {
    this.tramiteStatusSubscription.unsubscribe();
  }

  getTramiteStatusById(id: number): TramiteStatus {
    return this.tramiteStatus.find((ts) => ts.estado_id === id);
  }

  onSelectEmpresa(empresa: EntidadesProductivaNombrePFoJ) {
    let auxCE: CurrentEmpresa = {
      nombre: empresa.nombrePersonaFoJ,
      id: empresa.idEntidadProductiva
    };

    this.store.dispatch(
      entityCurrentEmpresaLoadRequest({
        item: auxCE
      })
    );

    this.router.navigateByUrl(this.returnRoute);
  }
}
